import { render, staticRenderFns } from "./CRatioInfo.vue?vue&type=template&id=9802633e&"
import script from "./CRatioInfo.vue?vue&type=script&lang=js&"
export * from "./CRatioInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports